export enum TaxClassification {
  C_CORPORATION = 'C-Corporation',
  S_CORPORATION = 'S-Corporation',
  PARTNERSHIP = 'Partnership',
}
